export default __webpack_public_path__ + "media/images/amenities/bath_towel-0bb84b174213755ef1c9da28d8b8680a.jpeg";